import { z } from "zod"

export const certificateTransferSchema = z.object({
  contactId: z.string(),
  certificateId: z.string().uuid(),
})
export type certificateTransferValidationType = z.infer<
  typeof certificateTransferSchema
>

export enum CertificateCategory {
  TRANSACTION = "TRANSACTION",
  SCOPE = "SCOPE",
  OTHER_INITIATIVES = "OTHER_INITIATIVES",
  UNKNOWN = "UNKNOWN",
}

export const CertificateCategorySchema = z.nativeEnum(CertificateCategory)

export const getCertificateTypeParamsSchema = z.object({
  category: CertificateCategorySchema.optional(),
})
export type getCertificateTypeParamsValidationType = z.infer<
  typeof getCertificateTypeParamsSchema
>
